import angular from 'angular';
import environment from "json!../../../config/config.json";
import parameters from "json!../../../config/parameters.json";

const configModule = angular.module('app.config', [])
    .constant('CONFIG', angular.merge({}, environment, parameters))
    .name;

export default configModule;


// WEBPACK FOOTER //
// ./client/app/config/config.js